import React from "react";

interface IWidgetErrorBoundaryState {
  hasError: boolean;
}

interface IProps {
  errorLogger?(eror: Error, errorInfo: any): void;
}

export class WidgetErrorBoundary extends React.Component<
  React.PropsWithChildren<IProps>,
  IWidgetErrorBoundaryState
> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // Report error to error handling service, if specified
    this.props.errorLogger?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return <>{this.props.children}</>;
  }
}
